module.exports = __webpack_public_path__ + "static/media/sami.e6236e5e.png";